import type { DashboardStats } from '../types/admin';
import { mockPatients } from './patients';

export const mockDashboardStats: DashboardStats = {
  total_patients: mockPatients.length,
  active_treatments: mockPatients.filter((p) => p.active_treatment_status === 'active').length,
  pending_deliveries: 3,
  pending_payments: 5,
};
